export class SetCustomTopUpValueAction {
  static readonly type = '[Payment] Set custom top up value';

  constructor(public customToUpValue: number) {
  }
}
